export const hostname = () => {
  if (import.meta.env.VITE_SENTRY_ENV == 'production') {
    return window.location.hostname;
  } else {
    // Uncomment this to override the hostname custom domain testing
    const override = {
      // 0: 'rm-test.nuovar.com',
    };
    return override?.[0 as keyof typeof override] || window.location.hostname;
  }
};

export const disableDomainCache = () => {
  if (import.meta.env.VITE_SENTRY_ENV == 'production') {
    return false;
  } else {
    return true;
  }
};
